<template>
  <div>
    <section class="section category-summary is-category-summary">
      <p v-if="!isMobileAds" class="has-text-centered">
        <ad v-on:ad-loaded="updateAdCounter" :ad-object="firstAd" :no-margin="hideFirstDesktopAd"></ad>
      </p>
      <p v-if="fetchingCategory" class="has-text-centered spinner">
        <img src="/static/img/spinner.svg" alt="Getting category detail" />
      </p>
      <flash-message size="is-size-6" :class="{'is-error':isError}"></flash-message>
      <div v-if="!fetchingCategory" class="level is-mobile">
        <div class="level-left category-header">
          <div class="level-item category-icon">
            <div class="img-container" :style="{backgroundImage: `url(${getBackgroundImage})`}"></div>
            <span class="is-mobile-only is-hidden-tablet">
              <h1>
                <strong class="business-name">{{category.h1}}</strong>
              </h1>
            </span>
          </div>
          <div class="level-item category-description">
            <div class="summary">
              <h1>
                <strong class="business-name is-hidden-mobile">{{category.h1}}</strong>
              </h1>
              <span class="review-summary">{{category.sort_description}}</span>
            </div>
          </div>
        </div>
      </div>
    </section>
    <p v-if="isMobileAds" class="has-text-centered">
      <ad v-on:ad-loaded="updateAdCounter" :ad-object="firstAd"></ad>
    </p>
    <p v-if="!isMobileAds" class="has-text-centered">
      <ad v-on:ad-loaded="updateAdCounter" :ad-object="secondAd"></ad>
    </p>
    <section class="section business-columns editing" v-if="!fetchingCategory && isError">
      <div class="columns is-paddingless is-marginless business-columns-outer">
        <div class="column is-marginless is-two-thirds-desktop business-columns-inner">
          <div class="container left-pane">
            <h2>
              <strong>Compare reviews for Best {{category.name}}</strong>
            </h2>
            <div class="columns is-multiline">
              <div class="column is-full-tablet">
                <div class="card" v-for="(bestBiz,index) in category.bestBiz" :key="index">
                  <div class="columns is-paddingless business-row is-multiline">
                    <div class="column padd-5 business-name">
                      <p class="has-text-weight-bold">
                        <a @click="bizProfile(bestBiz.slug)">{{bestBiz.name}}</a>
                      </p>

                    </div>
                    <div class="new-box-flex">
                      <div class="column is-narrow">
                        <div>
                          <rating
                            :stars="bestBiz.average_rating"
                            :isAvg="true"
                            :review-card="compress"
                          ></rating>
                        </div>
                      </div>
                      <div class="column">
                        <p
                          class="has-text-right-tablet has-text-left-mobile"
                        >{{bestBiz.review_count}} reviews | TrustIndex {{bestBiz.current_trust_index  | castTrustIndex(1)  }} | #{{index+1}} in {{category.name}}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <p v-if="isMobileAds" class="has-text-centered">
          <ad v-on:ad-loaded="updateAdCounter" :ad-object="secondAd"></ad>
        </p>
        <div class="column right-column" id="category-left-panel">
          <div
            class="container"
            :class="[!isShowMoreClicked ? 'show-more-clicked' : 'show-less-clicked']"
            v-html="category.long_description"
          ></div>
          <div class="show-more-link" @click="showMoreContent()">
            <a>{{!isShowMoreClicked? 'Show more': 'Show less'}}</a>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
  /* global googletag */
  /* eslint no-undef: "error" */

  import axios from 'axios'
  import Rating from '@/components/Rating'
  import FlashMessage from '@/components/FlashMessage'
  import adsConfig from '@/mixins/ad_config'
  import Ad from '@/components/ProgrammaticAds'

  export default {
    name: "BestBusiness",
    components: {
      Rating,
      FlashMessage,
      Ad
    },
    mixins: [adsConfig],
    data: function() {
      return {
        categorySlug: "",
        fetchingCategory: false,
        category: {},
        compress: true,
        isShowMoreClicked: false,
        metaTitle: "",
        metaDescription: "",
        metaCanonical: "",
        isError: false
      };
    },
    metaInfo() {
      return {
        title: this.metaTitle,
        meta: [{ name: "description", content: this.metaDescription }],
        bodyAttrs: {
          class: "best-biz"
        },
        link: [
          {
            rel: "canonical",
            href: `${window.location.protocol}//${window.location.host}${this.$route.path}`
          }
        ]
      };
    },
    created() {
      window.events.$on("best-biz", this.getCategoryDetail);
      this.getCategoryDetail();
    },
    mounted () {
      this.loadAds()
    },
    computed: {
      getBackgroundImage() {
        return `/static/img/industries/svg/${this.category.industry_slug}.svg`
      }
    },
    methods: {
      getCategoryDetail() {
        this.fetchingCategory = true;
        this.categorySlug = this.$route.params.slug
        this.isShowMoreClicked = false
        axios
          .get(`/business/bestbiz/${this.categorySlug}`)
          .then(({ data }) => {
            this.category = data
            this.metaTitle = data.title
            this.metaDescription = data.description
            this.fetchingCategory = false
            this.isError = true
            this.$gtm.trackEvent({
                event: 'pageLoad',
                virtualPageUrl: this.$router.currentRoute.path,
                virtualPageTitle: data.title,
                brandName: '',
                industryName: ''
            })
            googletag.cmd.push(() => {
              googletag.pubads().setTargeting('Pagetype', this._routeName)
              googletag.pubads().setTargeting('URL', window.location.href)
              googletag.pubads().setTargeting('BestBusinessCategory', data.name)
              googletag.pubads().collapseEmptyDivs()
              googletag.enableServices()
            })
          })
          .catch(error => {
            let errorMessage = "There was an error retreiving all of the Categories"
            if (error.response && !error.response.data.success) {
              errorMessage = error.response.data.message
            }
            this.isError = false
            flash(error.response.data.message, "is-danger", true)
            this.fetchingCategory = false
          });
      },
      bizProfile(slug) {
        this.$router.push(`/${slug}`)
      },
      showMoreContent() {
        this.isShowMoreClicked = !this.isShowMoreClicked
      }
    }
  }
</script>
<style scoped>
.category-summary {
  width: 100%;
  max-width: 1125px;
  padding: 3rem 0 0 0;
  margin: 0 auto;
}
.img-container {
  width: 140px;
  height: 140px;
  background-color: #ffffff;
  border-radius: 50%;
  display: block;
  background-size: 50%;
  background-position: center;
  background-repeat: no-repeat;
}
.category-icon {
  justify-content: left;
}
.category-description {
  width: 80% !important;
  align-items: flex-start;
}
.summary h1 {
  margin-bottom: 10px;
}
.level-left.category-header {
  flex-shrink: initial;
}
.section.business-columns > .columns > .column#category-left-panel {
  background-color: #f5f5f5;
  padding-bottom: 30px;
}
.section.business-columns {
  border-top: 1px solid lightgray;
  padding: 0;
}
.left-pane {
  padding-left: 150px;
  width: 100%;
  max-width: 710px;
  margin-bottom: 30px;
}
.right-column > .container {
  width: 453px;
  margin-left: 38px;
  color: #58595b;
}
.show-more-link {
  padding-left: 38px;
  display: inline-block;
  padding-top: 15px;
}
.show-more-link a {
  text-decoration: underline;
  color: #30aae1;
}
.left-pane .is-full-tablet {
  padding-left: 0;
  padding-right: 0;
}
.left-pane h2 {
  font-size: 25px;
  margin-top: 50px;
}
.right-column h3:first-child {
  margin-top: 50px;
  padding-bottom: 1rem;
}
.left-pane h3 {
  font-size: x-large;
}
.left-pane .is-multiline {
  margin-left: 0px;
  flex-direction: column;
}
strong {
  color: #58595b;
  font-size: 25px;
}
.right-column p {
  font-size: 14px;
}
ul.industry-business li {
  display: inline-block;
}
.new-box-flex {
  display: flex;
}

.new-box-flex .column {
  padding: 5px 0px;
}
.padd-5 {
  padding: 5px 10px;
}
.is-multiline {
  margin-top: 5px;
}
.editing .card {
  box-shadow: none;
  border-bottom: 1px solid #c9c9c9;
  padding-bottom: 25px;
  margin-right: 40px;
}
.editing .card:last-child {
  border: none;
}
.editing .has-text-left-mobile {
  text-align: left !important;
  font-size: 14px;
  color: #58595b;
}
.right-10 {
  padding-right: 10%;
}
.editing p a {
  color: #58595b;
}
.business-name {
  padding-left: 0px;
}
.business-row p a {
  color: #58595b;
  font-size: 14px;
}
.category-description .summary {
  font-size: 14px;
}
.category-description .summary strong {
  font-size: 25px;
  text-transform: capitalize;
}
.business-columns .is-two-thirds-desktop {
  width: 55%;
}
.is-error {
  display: none;
}
.show-less-clicked{
  height: auto;
  overflow: visible;
}
.show-more-clicked{
  height: 950px;
  overflow: hidden;
}
.show-more-clicked:before {
    content: '';
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    background: rgb(245,245,245);
    background: -moz-linear-gradient(0deg, rgba(245,245,245,1) 0%, rgba(255, 255, 255, 0) 5%);
    background: -webkit-linear-gradient(0deg, rgba(245,245,245,1) 0%, rgba(255, 255, 255, 0) 5%);
    background: linear-gradient(0deg, rgba(245,245,245,1) 0%, rgba(255, 255, 255, 0) 5%);
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#f5f5f5",endColorstr="#00d4ff",GradientType=1);
}
@media (min-width: 768px) and (max-width: 1024px) {
  .business-columns-outer {
    display: block;
  }
  .business-columns-inner {
    width: 100% !important;
  }
  .business-columns-inner .container {
    padding-right: 0;
  }
  .business-columns-inner .container .is-multiline {
    padding-right: 13px;
  }
  .business-name p {
    margin-left: 0;
  }
  .is-two-thirds-desktop .left-pane {
    padding-left: 0;
  }
  .new-box-flex .column {
    padding-left: 0;
  }

  .category-description .summary {
    padding-right: 30px;
  }
  .category-icon {
    margin: 0 0.75rem;
  }
  .right-column > .container {
    width: auto;
    margin-left: 0;
    padding: 0 18px 0 18px;
  }
  .category-description p {
    margin-right: 25px;
  }
  .is-two-thirds-desktop {
    padding: 0px 25px;
  }
  .show-more-link {
    padding-left: 18px;
  }
  .editing .card{
    margin-right: 0;
  }
}

@media (max-width: 767px) {
  .left-pane h2 {
    font-size: inherit;
  }
  .left-pane {
    margin: 10px 35px 35px auto;
  }
  .business-columns-inner {
    width: 100% !important;
  }
  .business-columns-inner .container {
    padding: 12px;
  }
  .new-box-flex {
    flex-direction: column;
  }
  .editing .has-text-left-mobile {
    padding-left: 0;
  }
  .editing .has-text-left-mobile {
    font-size: 12px;
    max-width: 300px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .editing .card {
    padding-bottom: 15px;
    margin-right: 15px;
  }
  .editing .left-pane h3 {
    font-size: inherit;
  }
  .category-header {
    width: 100% !important;
    padding: 0 25px 0 25px;
    flex-direction: column;
  }
  .category-description {
    width: 100% !important;
  }
  .container .is-multiline {
    padding-right: 25px;
  }
  .category-icon {
    padding-left: 0px;
    margin-right: 0px;
    width: 100%;
  }
  .category-icon h1 strong {
    font-size: 18px;
  }
  .category-icon .img-container {
    width: 100px;
    height: 70px;
  }
  .is-two-thirds-desktop .left-pane {
    padding-right: 0;
    margin-bottom: 16px;
  }
  .right-column > .container {
    width: 100%;
    margin-left: 13px;
    padding-right: 25px;
  }
  .business-row p a {
    font-size: 14px;
  }
  .business-columns-inner h2 {
    margin-top: 0;
  }
  .business-columns-inner h2 strong {
    font-size: 18px;
  }
  .show-more-link {
    padding: 10px 0 0 15px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/business/BestBusiness.vue